import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Icons from "react-feather";
import { Link } from "react-router-dom";
import { getStorageValues } from "../../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../../utils/apiConfig";
import { logAuditEvent } from "../../../utils/auditLogger";
function Dashboard() {
  const [getTaskList, setTaskList] = useState([]);
  const [getTaskSummaryByStatus, setTaskSummaryByStatus] = useState([]);
  const [, setTaskSummaryByPriority] = useState([]);
  const [, setTaskSummaryByUser] = useState([]);
  const [getTaskSummaryByCompanyType, setTaskSummaryByCompanyType] = useState(
    []
  );
  const [getTotalLeads, setTotalLeads] = useState(0);
  const [getCompletedLeads, setCompletedLeads] = useState(0);
  const [getPendingLeads, setPendingLeads] = useState(0);
  const [, setAllLeads] = useState([]);
  const [getRecentPendingLeads, setRecentPendingLeads] = useState([]);
  const [getFollowups, setFollowups] = useState([]);
  const renderTaskSummaryByStatus =
    getTaskSummaryByStatus.length > 0 ? (
      getTaskSummaryByStatus.map((obj, index) => {
        return (
          <div       
            className={
              "col-xl-" +
              Math.round(12 / getTaskSummaryByStatus.length) +
              " col-sm-5 col-12 d-flex"
            }
            key={obj.TaskingTermId || index}
          >
            <div className="dash-widget w-100">
              <div className="dash-widgetimg1">
                {obj.TaskingTerm === "Needs Review" ? (
                  <span>
                    <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: "Needs Review" }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        <img src="/assets/img/icons/needs-review.svg" alt="img" />
                    </Link>
                  </span>
                ) : obj.TaskingTerm === "In Progress" ? (
                  <span>
                    <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: "In Progress" }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        <img src="/assets/img/icons/in-progress.svg" alt="img" />
                    </Link>
                  </span>
                ) : obj.TaskingTerm === "On Hold" ? (
                  <span>
                    <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: "On Hold" }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        <img src="/assets/img/icons/on-hold.svg" alt="img" />
                    </Link>
                  </span>
                ) : obj.TaskingTerm === "Completed" ? (
                  <span>
                    <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: "Completed" }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        <img src="/assets/img/icons/completed.svg" alt="img" />
                    </Link>
                  </span>
                ) : (
                  <span>
                    <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: "Completed" }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        <img src="/assets/img/icons/in-progress.svg" alt="img" />
                    </Link>
                  </span>
                )}
              </div>
              <div className="dash-widgetcontent">
                <h5>               
                  <span className="counters" data-count={obj.TaskingCount}>
                    <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: obj.TaskingTerm }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        {obj.TaskingCount}
                    </Link>
                    
                  </span>
                </h5>
                <h6>
                   <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: obj.TaskingTerm }} // ✅ pass status name
                        className="view-all d-flex align-items-center">
                        <span>Total <b>{obj.TaskingTerm}</b> Tasks</span>
                    </Link> 
                </h6>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div className="col-12">
        <div className="centered-card-message">
          No Task has been created yet!!
        </div>
      </div>
    );
  const renderTaskSummaryByCompanyType =
    getTaskSummaryByCompanyType.length > 0 ? (
      getTaskSummaryByCompanyType.map((obj, index) => {
        return (
          <div className={
                 "col-xl-" +
                 Math.round(12 / getTaskSummaryByCompanyType.length) +
                 " col-sm-6 col-12"
               }
               key={obj.TaskingTermId || index}>
            <div className={"dash-count das" + index}>
              <div className="dash-counts">
                <h4>
                  <Link
                    to="/home/manage-task"
                    state={{ DefaultCompanyTypeFilter: obj.TaskingTerm.trim() }}>
                    <b>{obj.TaskingCount}</b>
                  </Link>
                </h4>
                <h5>
                    <Link
                      to="/home/manage-task"
                      state={{ DefaultCompanyTypeFilter: obj.TaskingTerm.trim() }}>
                      <b>{obj.TaskingTerm}</b>
                    </Link>
                </h5>
              </div>
              <div className="dash-imgs">
                <img 
                  src={ obj.TaskingTerm.trim() === "Mutual Fund" ? "/assets/img/icons/funding.png" 
                      : obj.TaskingTerm.trim() === "Mediclaim" ? "/assets/img/icons/medical.png" 
                      : obj.TaskingTerm.trim() === "Insurance" ? "/assets/img/icons/insurance1.png" 
                      : obj.TaskingTerm.trim() === "Borking" ? "/assets/img/icons/broking.png"
                      : "/assets/img/icons/log-out.svg"}
                  alt="img" 
                />
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div className="col-12">
        <div className="centered-card-message">
          No Task has been created yet!!
        </div>
      </div>
    );

  const fetchTaskSummaryByType = async (summaryType) => {
    try {
      let taskDetails = {
        UserId: getStorageValues("userId"),
        SummaryType: summaryType,
      };
      const response = await axios.get(getApiBaseUrl() + "/getTaskingSummary", {
        params: taskDetails,
      });
      if (response.status === 200) {
        if (summaryType === "Status") {
          setTaskSummaryByStatus(response.data.data[0]);
        } else if (summaryType === "Priority") {
          setTaskSummaryByPriority(response.data.data[0]);
        } else if (summaryType === "User") {
          setTaskSummaryByUser(response.data.data[0]);
        } else {
          setTaskSummaryByCompanyType(response.data.data[0]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTask = async () => {
    try {
      let taskDetails = {
        UserId: getStorageValues("userId"),
        ByUser: 1,
      };
      const response = await axios.get(
        getApiBaseUrl() + "/tasklist",
        { params: taskDetails }
      );
      if (response.status === 200) {
        setTaskList(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchLead = async () => {
    try {
      const LeadDetails = { UserId: getStorageValues("userId") };
      const response = await axios.get(getApiBaseUrl() + "/leadList", {
        params: LeadDetails,
      });

      if (response.status === 200) {
        setAllLeads(response.data.data[0]);
        setTotalLeads(response.data.data[0].length);
        setCompletedLeads(
          response.data.data[0].filter((x) => x.IsConverted === "Converted")
            .length
        );
        setPendingLeads(
          response.data.data[0].filter((x) => x.IsConverted === null).length
        );
        setRecentPendingLeads(
          response.data.data[0]
            .filter((x) => x.IsConverted === null)
            .splice(0, 5)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchFollowup = async () => {
    try {
      const followupDetails = { UserId: getStorageValues("userId") };
      const response = await axios.get(getApiBaseUrl() + "/getFollowupList", {
        params: followupDetails,
      });

      if (response.status === 200) {
        setFollowups(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    logAuditEvent('Dashboard', 'Accessed Module', 'Accessed Dashboard');
  }, []);

  useEffect(() => {
    fetchTaskSummaryByType("Status");
    fetchTaskSummaryByType("Priority");
    fetchTaskSummaryByType("User");
    fetchTaskSummaryByType("ClientCompanyType");
    fetchTask();
    fetchLead();
    fetchFollowup();
  }, []);
  return (
    <>

      <div className="row sales-cards">{renderTaskSummaryByCompanyType}</div>

      {/* <div className="row">
                {renderTaskSummaryByPriority}
            </div> */}
            
      <div className="row">{renderTaskSummaryByStatus}</div>
      <div className="row">
        <div className="col-xl-6 col-sm-12 col-12 d-flex">
            <div className="card flex-fill default-cover mb-4">
            <div className="card-header d-flex justify-content-between align-items-center bg-tableheader">
                <h4 className="card-title mb-0">
                {"Total Leads " +
                    getTotalLeads +
                    ", " +
                    getCompletedLeads +
                    " completed, " +
                    getPendingLeads +
                    " pending"}
                </h4>
                <div className="view-all-link">
                <Link
                    className="view-all d-flex align-items-center alink-white"
                    to="/home/lead"
                >
                    View All
                    <span className="ps-2 d-flex align-items-center">
                    {<Icons.ArrowRight size={17} className="arroright" />}
                    </span>
                </Link>
                </div>
            </div>
            <div className="card-body">
                <div className="table-responsive dataview">
                <table className="table dashboard-recent-products table-hover">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Client Name</th>
                        <th>Investement Product</th>                       
                        <th>Mobile No</th>
                         <th>Email ID</th>
                    </tr>
                    </thead>
                    <tbody>
                    {getRecentPendingLeads.length > 0 ? (
                        getRecentPendingLeads.map((obj, index) => {
                        return (
                            <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{obj.ClientName}</td>
                            <td>{obj.ClientCompanyTypeNames}</td>                           
                            <td>{obj.MobileNumber}</td>
                             <td>{obj.EmailId}</td>
                            </tr>
                        );
                        })
                    ) : (
                        <tr>
                        <td colSpan="6" className="text-center">
                            No latest leads found!!
                        </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        <div className="col-xl-6 col-sm-12 col-12 d-flex">
            <div className="card flex-fill default-cover mb-4">
            <div className="card-header d-flex justify-content-between align-items-center bg-tableheader">
                <h4 className="card-title mb-0">
                {"Follow up"}
                </h4>
                {/* <div className="view-all-link">
                <Link
                    className="view-all d-flex align-items-center alink-white"
                    to="/home/manage-task"
                >
                    View All
                    <span className="ps-2 d-flex align-items-center">
                    {<Icons.ArrowRight size={17} className="arroright" />}
                    </span>
                </Link>
                </div> */}
            </div>
            <div className="card-body">
                <div className="table-responsive dataview">
                <table className="table dashboard-recent-products table-hover">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Key</th>
                        <th>Client Name</th>
                        <th>Follow Up  Date</th>
                        <th>Remark</th>
                    </tr>
                    </thead>
                    <tbody>
                    {getFollowups.length > 0 ? (
                        getFollowups.map((obj, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                    {obj.FollowupType === 'Task' ? (
                                <Link
                                  to="/home/manage-task"
                                          state={{ DefaultTaskId: obj.TaskId, DefaultTaskKey: obj.TaskKey, showFollowupTab: true }}
                                  title="Click to open the task follow-up"
                                >
                                  {obj.TaskKey}
                                </Link>
                              ) : (
                                <span title={obj.TaskKey}>{obj.TaskKey}</span>
                              )}
                                </td>
                                <td>{obj.ClientName}</td>
                                <td>{obj.FollowupDate}</td>
                                <td>{obj.FollowupRemarks}</td>
                            </tr>
                        );
                        })
                    ) : (
                        <tr>
                        <td colSpan="6" className="text-center">
                            No latest followups found!!
                        </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
      </div>

      <div className="row">
        
        {(() => {
          // ✅ 1. Extract unique task statuses from getTaskList
          const uniqueStatuses = [
            ...new Set(getTaskList.map((task) => task.Status)),
          ];

          // ✅ 2. Loop through each status and render the latest 5 tasks
          return uniqueStatuses.map((status, idx) => {
            const filteredTasks = getTaskList
              .filter((t) => t.Status === status)
              .slice(0, 5); // get latest 5

            return (
              <div key={status} className="col-sm-12 col-md-12 col-xl-6 d-flex">
                <div className="card flex-fill default-cover w-100 mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center bg-tableheader">
                    <h4 className="card-title mb-0">Task Status - {status}</h4>
                    <div className="dropdown">
                      <Link
                        to="/home/manage-task"
                        state={{ DefaultStatusFilter: status }} // ✅ pass status name
                        className="view-all d-flex align-items-center alink-white"
                      >
                        View All
                        <span className="ps-2 d-flex align-items-center">
                          <Icons.ArrowRight size={17} />
                        </span>
                      </Link>
                    </div>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-nowrap table-hover">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Key</th>
                            <th>Title</th>
                            <th>Assigned To</th>
                            <th>Priority</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredTasks.map((obj, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <Link
                                  to="/home/manage-task"
                                  state={{ DefaultTaskId: obj.TaskId }}
                                  title="Click to open the task!"
                                >
                                  {obj.TaskKey}
                                </Link>
                              </td>
                              <td>{obj.Title}</td>
                              <td>{obj.AssignedTo}</td>
                              <td>{
                                obj.Priority === "Critical" ? <span className="badge bg-high">{obj.Priority}</span> 
                                :  obj.Priority === "High" ?  <span className="badge bg-danger">{obj.Priority}</span> 
                                :  obj.Priority === "Medium" ?  <span className="badge bg-success">{obj.Priority}</span> 
                                :  obj.Priority === "Low" ?  <span className="badge bg-warning">{obj.Priority}</span> 
                                :  obj.Priority === "Planning" ?  <span className="badge bg-purple">{obj.Priority}</span> 
                                :  obj.Priority === "Cancelled" ?  <span className="badge bg-teal">{obj.Priority}</span> 
                                : <span className="badge bg-primary">{obj.Priority}</span>
                              }</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            );
          });
        })()}
      </div>
    </>
  );
}

export default Dashboard;
